import { createFileRoute } from "@tanstack/react-router";
import { PublicOrderDetail } from "@/features/public/orders";

export const Route = createFileRoute(
  "/(member)/(public)/public/orders/$orderId",
)({
  component: PublicOrderDetail,
});
